/**
 * A Brazilian phone as it's typed: (48) 9999-0000 for landlines, (48) 99999-0000 for mobiles, formatted as the
 * digits come in (at most 11). Anything that isn't a digit is dropped.
 */
export const formatBrazilianPhone = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 2) {
    return digits.length ? `(${digits}` : "";
  }
  const area = digits.slice(0, 2);
  const number = digits.slice(2);
  // Mobile (9 digits after the area code) splits 5-4; landline (8) splits 4-4
  const split = number.length > 8 ? 5 : 4;
  return number.length > split ? `(${area}) ${number.slice(0, split)}-${number.slice(split)}` : `(${area}) ${number}`;
};

/** The phone formatted for the country: Brazil's mask, or as typed elsewhere. */
export const formatPhone = (value: string, country?: string) =>
  (country || "BR").toUpperCase() === "BR" ? formatBrazilianPhone(value) : value;
